
<app-booking-navbar [step]="5"></app-booking-navbar>


<div class="row">
    <div class="col-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">

        <mat-card class="mt-3">
            <mat-card-content>

<div class="row" *ngIf="(basket$ | async)">
    <div class="col-12">



            <div class="row mt-4 mb-5">
                <div class="col-6">
                <h2 class="mat-title mb-2">Book a restaurant reservation</h2>
                </div>
                <div class="col-6 text-right">
                    <button class="btn btn-primary" *ngIf="!tableBooking.lockResult" (click)="ignore()">
                        Continue without dining
                    </button>
                </div>
            </div>


            <div class="mb-3">

                    <p style="font-weight: bold;">Confirm guest details</p>

                    <div class="row">
                        <div class="col-6">
                            <input class="form-control" placeholder="First name" [(ngModel)]="tableBooking.booker.firstname" />
                        </div>
                        <div class="col-6">
                            <input class="form-control" placeholder="Surname" [(ngModel)]="tableBooking.booker.surname" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-6">
                            <input class="form-control" placeholder="email" [(ngModel)]="tableBooking.booker.email" />
                        </div>
                        <div class="col-6">
                            <input class="form-control" placeholder="Telephone" [(ngModel)]="tableBooking.booker.telephone" />
                        </div>
                    </div>


            </div>



            <div>

                    <p style="font-weight: bold;">How many guests will be at dinner?</p>

                    <div class="row">
                        <div class="col-3">
                            <select
                                [(ngModel)]="tableBooking.partySize"
                                (ngModelChange)="refreshAvailability()"
                                class="form-control">
                                <option [ngValue]="1">1</option>
                                <option [ngValue]="2">2</option>
                                <option [ngValue]="3">3</option>
                                <option [ngValue]="4">4</option>
                                <option [ngValue]="5">5</option>
                                <option [ngValue]="6">6</option>
                            </select>

                        </div>
                    </div>

                    <ng-container *ngIf="!slots.length">
                        <p class="mt-4">Sorry, there are no tables available for your party size or date</p>
                    </ng-container>

                    <ng-container *ngIf="slots.length">
                        <p class="mt-4" style="font-weight: bold;">Please select your preferred time for dinner</p>
                        <ng-container *ngFor="let s of slots; let sIdx = index">
                            <div *ngIf="s.available" class="otButton" [ngClass]="{'otButtonSelected': tableBooking.slotSelected === s.time}" (click)="selectSlot(s)">{{s.time | date: 'HH:mm'}}</div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="tableBooking.slotSelected && !dupeBooking">
                        <!-- <p class="mt-4">Available seating options</p>
                        <ng-container *ngFor="let a of areas; let aIdx = index">
                            <div class="otButton" [ngClass]="{'otButtonSelected': tableBooking.area === a.id}" (click)="selectArea(a)">{{a.name}}</div>
                        </ng-container> -->

                        <ng-container *ngFor="let da of diningAreas">
                            <p class="mt-4">{{da.name}} <span *ngIf="da.environment"> ({{da.environment}})</span></p>
                            <ng-container *ngFor="let a of da.attributes; let aIdx = index">
                                <div class="otButton" [ngClass]="{'otButtonSelected': tableBooking.area === da.id && tableBooking.reservationAttribute === a}" (click)="selectAttribute(da, a)" style="text-transform: capitalize">{{a.replace('default', 'Standard')}}</div>
                            </ng-container>

                        </ng-container>

                        <div *ngIf="!tableBooking.lockResult">
                            <p class="mt-3">Please let us know about any special needs or dietary requirements:</p>
                            <textarea class="form-control" style="height: 80px" [(ngModel)]="tableBooking.dietary"></textarea>
                        </div>


                        <!-- <ng-container *ngFor="let a of attributes; let aIdx = index">
                            <ng-container *ngIf="isAvailable(a)">
                                <div class="otButton" [ngClass]="{'otButtonSelected': tableBooking.reservationAttribute === a}" (click)="selectAttribute(a)" style="text-transform: capitalize">{{a.replace('default', 'Standard')}}</div>
                            </ng-container>
                        </ng-container> -->

                    </ng-container>

                    <div class="alert alert-danger mt-3" *ngIf="dupeBooking">
                        <p class="mb-0" style="color: white;">You aleady have a booking at this restaurant within a 2 hour period</p>
                    </div>
            </div>



            <!-- <div class="addOns-cost">
                <p class="text">Total cost of extras</p>
                <p class="cost">{{(basket$ | async).totals.addOnsTotal | currency: 'GBP'}}</p>
            </div> -->
            <div *ngIf="tableBooking.lockResult">
                <div *ngIf="tableBooking.lockResult.success">
                    <p>Your reservation has been held and will expire at {{expiresAtLocal | date: 'HH:mm:ss'}}</p>
                    <p>Please checkout before this time otherwise your booking will be removed.</p>
                </div>
                <div *ngIf="!tableBooking.lockResult.success">
                    <p class="text-danger">Sorry, there was a problem securring your booking slot</p>
                    <!-- <p>Please checkout before this time otherwise your booking will be removed.</p> -->
                </div>
            </div>

            <div class="row mt-4 mb-5" *ngIf="!tableBooking.lockResult && tableBooking.slotSelected && tableBooking.area">
                <div class="col-6">
                    <p style="font-size: 10px; font-style: italic;">By clicking ‘Complete reservation’ you agree to the OpenTable <a href="https://www.opentable.co.uk/c/legal/terms-and-conditions/" target="_blank">Terms of Use</a> and <a href="https://www.opentable.com/c/legal/privacy-policy/" target="_blank">Privacy Policy.</a></p>
                </div>
                <div class="col-6 text-right">
                    <button class="btn btn-primary" (click)="slotLock()">
                        Complete reservation
                    </button>
                </div>
            </div>


            <div class="row mt-4 mb-5" *ngIf="tableBooking.lockResult">
                <div class="col-6">
                </div>
                <div class="col-6 text-right">
                    <button class="btn btn-primary" (click)="continue('')">
                        Continue
                    </button>
                </div>
            </div>


            <div class="alert alert-danger mt-3" *ngIf="error">
            <p class="mb-0">{{error}}</p>
            </div>



        <div class="mt-4 mb-4">
            <span style="font-size: 14px;">Powered by </span>
            <img src="assets/images/opentable.png" style="height: 35px;" />

        </div>
    </div>
</div>

</mat-card-content>
</mat-card>


    </div>
</div>
